import React, { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs, doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function ReportsDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const currentUser = auth.currentUser;

  const adminUid = 
    "k3DpjIB3I9cUoT48cPuepTjhKIZ2"; // 🔐 Sostituisci con il tuo UID da Firebase

  useEffect(() => {
    if (!currentUser) return;

    if (currentUser.uid !== adminUid) {
      navigate("/"); // Non sei admin → torna alla home
      return;
    }

    const fetchReports = async () => {
      const q = query(collection(db, "reports"), orderBy("createdAt", "desc"));
      const snap = await getDocs(q);
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setReports(data);
    };

    fetchReports();
  }, [currentUser, navigate]);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} - ${date.getHours()}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const handleDeleteReport = async (id) => {
    const confirm = window.confirm(t('auth.warnings.confirmDeleteReport'));
    if (!confirm) return;
    await deleteDoc(doc(db, "reports", id));
    setReports(prev => prev.filter(r => r.id !== id));
  };

  const handleRemoveProduct = async (report) => {
    const confirm = window.confirm(t('auth.warnings.confirmDeleteProduct'));
    if (!confirm) return;

    try {
      const ref = doc(db, "wishlists", report.wishlistId);
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        alert(t('auth.warnings.wishlistNotFound'));
        return;
      }

      const data = snap.data();
      const products = Array.isArray(data.products) ? [...data.products] : [];

      if (report.productIndex >= 0 && report.productIndex < products.length) {
        products.splice(report.productIndex, 1);
      } else {
        alert(t('auth.warnings.productNotFound'));
        return;
      }

      await updateDoc(ref, { products });
      alert(t('auth.warnings.productDeletedSuccess'));
    } catch (error) {
      console.error("Errore nell'eliminazione del prodotto:", error);
      alert(t('auth.warnings.genericError'));
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h2 style={styles.title}>Dashboard Segnalazioni</h2>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>Indietro</button>
      </div>

      {reports.length === 0 ? (
        <div style={styles.message}>Nessuna segnalazione trovata.</div>
      ) : (
        <div style={styles.grid}>
          {reports.map(r => (
            <div key={r.id} style={styles.card}>
              <img
                src={r.productData?.image || "https://via.placeholder.com/150"}
                alt={r.productData?.title}
                style={styles.image}
              />
              <div style={styles.content}>
                <div style={styles.section}>
                  <strong>Prodotto:</strong>{" "}
                  <a href={r.productData?.url} target="_blank" rel="noreferrer" style={styles.link}>
                    {r.productData?.title}
                  </a>
                </div>
                <div style={styles.section}>
                  <strong>Motivo:</strong> {r.reason}
                </div>
                <div style={styles.section}>
                  <strong>Segnalato da:</strong> {r.reportedBy}
                </div>
                <div style={styles.section}>
                  <strong>Data:</strong> {formatDate(r.createdAt)}
                </div>
                <button onClick={() => handleRemoveProduct(r)} style={styles.removeBtn}>
                  Elimina Prodotto Segnalato
                </button>
                <button onClick={() => handleDeleteReport(r.id)} style={styles.deleteBtn}>
                  Elimina Segnalazione
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  page: {
    padding: "20px",
    fontFamily: "Poppins, sans-serif",
    background: "#fff",
    minHeight: "100vh",
    color: "#000",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
    margin: 0,
  },
  backBtn: {
    background: "#000",
    color: "#fff",
    border: "none",
    padding: "6px 14px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  message: {
    textAlign: "center",
    marginTop: "50px",
    color: "#555",
  },
  grid: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  card: {
    display: "flex",
    gap: "14px",
    background: "#f9f9f9",
    borderRadius: "10px",
    border: "1px solid #ddd",
    padding: "12px",
    alignItems: "flex-start",
  },
  image: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    flexShrink: 0,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1,
  },
  section: {
    fontSize: "14px",
  },
  link: {
    color: "#000",
    textDecoration: "underline",
  },
  deleteBtn: {
    background: "#000",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    alignSelf: "flex-start",
    marginTop: "6px",
  },
  removeBtn: {
    background: "#fff",
    color: "#000",
    border: "1px solid #000",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    alignSelf: "flex-start",
    marginTop: "6px",
  },
};